module.exports = "<footer class=\"main-footer navbar-default navbar-fixed-bottom\" *ngIf=\"authService.loggedIn()\">\n     <strong>&copy; 2017 Welloculus. Developed by <a href=\"http://www.transility.com\" target=\"_blank\">Transility</a>.</strong>\n</footer>\n\n<footer class=\"main-footer navbar-default navbar-fixed-bottom loginfooter\" *ngIf=\"!authService.loggedIn()\">\n  <strong>&copy; 2017 Welloculus. Developed by <a href=\"http://www.transility.com\" target=\"_blank\">Transility</a>.</strong>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/footer/footer.component.html
// module id = 408
// module chunks = 1